angular.module('app').directive('notificacoes', function() {
	return {
        restrict: 'A',
        templateUrl: '/html/notificacoes.html?v='+angular.element('meta[name="version-id"]').attr('content'), 
        controller: function($scope, $element, $http, $timeout, $compile) {
            $scope.notifications = [];
            $scope.completeNotifications = 0;
            $scope.loading = false;
            
            $scope.getNotifications = function(complete){
                if(!$scope.completeNotifications){
                    $scope.loading = true;
                    $http({
                        'url':'/notificacoes/nao-lidas'
                    }).then(function(res){
                        $scope.completeNotifications = complete;
                        $scope.notifications = res.data;
                        if($scope.notifications.length === 0){
                            //Não precisa reobter se não tinha nenhuma
                            $scope.completeNotifications = true;
                        }
                        $scope.loading = false;
                    });
                }
            }

        },
        link: function ($scope, $element, attrs, ctrl) {
            $scope.getNotifications(0);

        }
    };
})